module.exports = __webpack_public_path__ + "img/about_kpi.885ea608.svg";